import React, { useEffect, useState } from "react"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
// import { Button } from "primereact/button"
import { useAppContext } from "../../../context/appContext"
import { COPILOT_NOTIFICATION_AUTO_TIMEOUT } from "../../../constants/constants.const"
// import AIhead from "./../../../images/Smile-Emoji.png"
import AIhead from "./../../../images/Chat icon_ inner pages.svg"
import arrow from "./../../../images/Black Nav Arrow.svg"
import workflowIcon from "./../../../images/workflowIcon.svg"
import thinking from "./../../../images/ThinkingBulbIcon.gif"
import success from "./../../../images/successFullRedIcon.svg"
import Link from "../../smartLink"
import MinimizedThinkingSteps from "@e-llm-studio/llmstudioui"

export const ChatMessageContent = React.memo(
  ({
    content,
    isSmallScreen,
  }: {
    content: string
    isSmallScreen?: boolean
  }) => {
    const relativePaths = url => {
      if (url.startsWith("/") && url.length > 2) {
        // console.log("Already a relative path:", url)
        return { type: "internal", link: url }
      }
      const match = url.match(/https?:\/\/(?:\w+\.)?techolution\.com(\/.*)/)
      // console.log("match", match)
      return match
        ? { link: match[1], type: "internal" }
        : { link: url, type: "external" }
    }
    return (
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        components={{
          // img: props => (
          //   <Image
          //     id={props.src}
          //     src={props.src}
          //     alt={props.alt}
          //     preview={true}
          //   />
          // ),
          a: ({ node, ...props }) => {
            let testLink = relativePaths(props.href)
            if (testLink.type === "internal") {
              if (!isSmallScreen)
                return (
                  //@ts-ignore
                  <Link
                    title={`Redirect to ${testLink.link}`}
                    className="chat-redirect-btn"
                    {...props}
                    to={testLink.link}
                  />
                )
              else return <a {...props} href={testLink.link} />
            } else
              return (
                <a
                  {...props}
                  target="_blank"
                  href={testLink.link}
                  rel="noopener noreferrer"
                />
              )
          },
        }}
      >
        {content?.replace(
          /innovate@techolution.com/g,
          '<a href="mailto:innovate@techolution.com">innovate@techolution.com</a>'
        )}
      </ReactMarkdown>
    )
  }
)

const ChatMessages = ({
  // scrollContainerRef,
  // lastPairRef,
  messageRefs,
  messageRef,
  idx,
  message,
  messageLoading,
  isStreaming,
  chatSettings,
  // showWaitingMessage,
  responseHadLessConfidanceScore,
  expertAnswerIds,
  // welcomeMsg,
  // groupedMessages,
  truncateMessage,
  setReplyMessage,
  setIsStreaming,
  openAccordions,
  setOpenAccordions,
}: // workflowStreaming,
// setWorkflowStreaming,
{
  messageRefs: React.MutableRefObject<(HTMLDivElement | null)[]>
  messageRef: any
  idx: any
  message: any
  messageLoading: boolean
  isStreaming: boolean
  chatSettings: any
  responseHadLessConfidanceScore: boolean
  expertAnswerIds: string[]
  setIsStreaming: any
  setOpenAccordions: any
  openAccordions: any
  truncateMessage: (message: any, maxLength: any) => any
  setReplyMessage: React.Dispatch<React.SetStateAction<string>>
  // workflowStreaming: boolean
  // setWorkflowStreaming: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const { state } = useAppContext()

  const [userToggle, setUserToggled] = useState<any>()

  const [msgHadLessConfidenceScore, setMsgHadLessConfidenceScore] =
    useState<boolean>(responseHadLessConfidanceScore)

  const [workflowStreaming2, setWorkflowStreaming2] = useState<boolean>(
    message.isEnd ? false : true
  )

  useEffect(() => {
    setMsgHadLessConfidenceScore(responseHadLessConfidanceScore)
  }, [responseHadLessConfidanceScore])

  useEffect(() => {
    if (msgHadLessConfidenceScore) {
      const timeoutLimit = COPILOT_NOTIFICATION_AUTO_TIMEOUT
      // parseInt(process.env.COPILOT_TIMEOUT ?? "80") * 1000 ?? 80000
      const timer = setTimeout(() => {
        setMsgHadLessConfidenceScore(false)
      }, timeoutLimit)

      return () => clearTimeout(timer)
    }
  }, [msgHadLessConfidenceScore])
  // console.log({
  //   "is assistant:": message.role,
  //   "is end:": workflowStreaming2,
  // })
  // console.log("workflowStreaming2:", message.isEnd)
  useEffect(() => {
    setWorkflowStreaming2(message.isEnd ? false : true)
  }, [message.isEnd])
  return (
    <div
      key={idx}
      className={`message-row ${message?.role} ${
        state.chatAiName === "vanai" ? "vanai" : "timai"
      } ${
        message?.role !== "user"
          ? msgHadLessConfidenceScore //lowConfidenceScoreIds?.includes(message?.requestId)
            ? "copilot-under-review-message"
            : expertAnswerIds?.includes(message?.requestId)
            ? "copilot-after-review-message"
            : "copilot-review-message"
          : "copilot-review-message"
      }`}
      // ref={el => (messageRefs.current[idx] = el)}
      ref={messageRef} // Use the local ref here
    >
      <div className="message-sender">
        {message?.role === "user" ? (
          <i className={`pi pi-user`} />
        ) : (
          <img src={AIhead} alt="AI profile pic" />
        )}
        <span>
          {state.chatAiName === "vanai"
            ? message?.role === "user"
              ? "You"
              : "Van AI"
            : ""}
        </span>
      </div>

      {/* Reply Message */}
      <div
        className={`message ${
          message?.role === "user" ? "user-message" : "chatbot-message"
        }`}
      >
        {message?.role !== "user" &&
        (expertAnswerIds?.includes(message?.requestId) ||
          msgHadLessConfidenceScore) ? (
          //lowConfidenceScoreIds?.includes(message?.requestId)) ? (
          <div
            className={`copilot-review-label ${
              msgHadLessConfidenceScore //lowConfidenceScoreIds?.includes(message?.requestId)
                ? "copilot-under-review-label"
                : "copilot-after-review-label"
            }`}
          >
            <span className="pi pi-circle-fill blink"></span>
            <span>
              {msgHadLessConfidenceScore //lowConfidenceScoreIds?.includes(message?.requestId)
                ? "Expert reviewing"
                : "Expert responded"}
            </span>
          </div>
        ) : (
          ""
        )}
        {
          // message.isAgent !== true &&
          message.content === "" && message.role === "assistant" && (
            <p style={{ paddingBottom: "1rem" }}>
              Thanks for asking! Finding the right answer for you now...
            </p>
          )
        }
        {message.role === "assistant" &&
          message?.assistantObject?.orchestratorAndAgentsMessages &&
          message?.assistantObject?.orchestratorAndAgentsMessages.length >
            0 && (
            <>
              <MinimizedThinkingSteps
                orchestratorAndAgentsMessages={
                  message?.assistantObject?.orchestratorAndAgentsMessages
                }
                isStreaming={workflowStreaming2}
                setIsStreaming={setWorkflowStreaming2}
                setUserToggled={setUserToggled}
                openAccordions={openAccordions}
                setOpenAccordions={setOpenAccordions}
                thinkingBulbIcon={thinking}
                completeIcon={success}
                arrowDownIcon={arrow}
                workFlowIcon={workflowIcon}
                containerClassName="chat-accordion-container"
              />
            </>
          )}
        <span className="message-text">
          {message.replyMessage && (
            <div
              className="reply-message-container"
              style={{
                width: "100%",
                marginLeft: "0px",
                marginRight: "0px",
              }}
            >
              <div className="reply-message-header">
                <span className="">Replied to Techoversity - AI</span>
              </div>
              <p className="reply-message">
                {truncateMessage(message?.replyMessage, 50)}
              </p>
            </div>
          )}
          {message.reply && (
            <div
              className="reply-message-container"
              style={{
                width: "100%",
                marginLeft: "0px",
                marginRight: "0px",
              }}
            >
              <div className="reply-message-header">
                <span className="">Replied to Techoversity - AI</span>
              </div>
              <p className="reply-message">
                {truncateMessage(message?.reply, 50)}
              </p>
            </div>
          )}
          <ChatMessageContent
            // content={message.content?.replace(message?.replyMessage, "")}
            content={
              !msgHadLessConfidenceScore
                ? message?.content?.replace(
                    `<p style=\"font-size: 0.8rem; font-family: ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\"><b>Note: The current response is below the confidence threshold. Please use the information carefully.</b></p>`,
                    ""
                  )
                : message?.content
            }
            isSmallScreen={
              state.isTab
                ? state.isTab
                : state.isMobile
                ? state.isMobile
                : false
            }
          />
        </span>
        {/* {message?.role !== "user" && chatSettings.isStreamResponseOn ? (
          <Button
            title="click to reply for this message"
            disabled={messageLoading || isStreaming}
            icon="pi pi-reply"
            onClick={() => setReplyMessage(message.content)}
            className="message-reply-button"
          />
        ) : (
          ""
        )} */}
      </div>
    </div>
  )
}

export default ChatMessages
